import { connect, useSelector } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import { getCurrentScreenSize } from '../../selectors';

type ResultType = ReturnType<typeof getCurrentScreenSize>;

export const useCurrentScreenSize = (): ResultType =>
  useSelector(getCurrentScreenSize);

export const withCurrentScreenSize = connect((state: GlobalState) => ({
  currentScreenSize: getCurrentScreenSize(state),
}));
